import "./App.css";
import Layout from "./components/Layout";
import Home from "./components/Home";
import Login from "./components/Login";
import Register from "./components/Register";
import Profile from "./components/Profile";
import NotFound from "./components/NotFound";
import {
  createBrowserRouter,
  RouterProvider,
  redirect,
} from "react-router-dom";

import { auth } from "./backend/firebase";

const CheckUserLoggedIn = () => {
  const user = auth.currentUser; // Check the current user directly from Firebase auth
  if (!user) {
    throw redirect("/login");
  }
  return null;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "profile",
        element: <Profile />,
        loader: CheckUserLoggedIn,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

function App() {
  return (
    <div className="App min-h-screen">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
